<template>
    <td-dialog :title="$t(title)" :before-close="jobDialogClose" :visible="dialogAddJobInfoIsible" width="600px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="fromJobInifo" :label-width="formLabelWidth" :label-position="right" ref="fromJobInifo" :rules="rules">
            <el-form-item :label="$t('common.JOB_NAME')" prop="jobName">
                <td-input v-model="fromJobInifo.jobName" :maxlength="inputLength"></td-input>
            </el-form-item>

            <el-form-item :label="$t('common.JOB_GROUP')" prop="groupName">
                <td-input v-model="fromJobInifo.groupName" :maxlength="inputLength"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.JOB_CRON')" prop="cron">
                <td-input v-model="fromJobInifo.cron" :special-character-check="false" :maxlength="inputLength"></td-input>
            </el-form-item>

            <el-form-item :label="$t('common.JOB_BEAN_PATH')" prop="jobClassPath">
                <td-input v-model="fromJobInifo.jobClassPath" width="100%" :maxlength="textArealength"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.JOB_CONCURRENT')" prop="concurrent">
                <td-switch v-model="fromJobInifo.concurrent" @change="concurrentChange"></td-switch>
            </el-form-item>
            <el-form-item v-if="jobConcurrent" :label="$t('common.JOB_NUMBER')" prop="jobNumber">
                <td-inputNumber v-model="fromJobInifo.jobNumber" :min="1" :max="65535" controls="true"></td-inputNumber>
            </el-form-item>

            <el-form-item v-if="!this.isAddData" :label="$t('common.ADD_TIME')" prop="addTime">
                <td-input v-model="fromJobInifo.addTime" :readonly="true"></td-input>
            </el-form-item>
            <el-form-item v-if="!this.isAddData" :label="$t('common.UPDATE_TIME')" prop="updateTime">
                <td-input v-model="fromJobInifo.updateTime" :readonly="true"></td-input>
            </el-form-item>

            <el-form-item :label="$t('common.DESCRIPTION')" prop="jobDescription">
                <td-input type="textarea" :rows="2" v-model="fromJobInifo.jobDescription" width="100%" :maxlength="textArealength"></td-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="loading" @click.native="submitForm('fromJobInifo')">{{ $t('common.SAVE') }}</td-button>
            <td-button @click.native="jobDialogClose">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import resourceApi from '../assets/api.js';
export default {
    props: ['title', 'dialogAddJobInfoIsible', 'editItem', 'isAddData'],
    created() {
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.initEditData();
        }
    },

    // 定义变量
    data() {
        // 任务名校验
        let checkJobNameExist = (rule, jobName, callback) => {
            let param = { jobName: jobName };
            resourceApi.chackJobNameExist(param, response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('/timedTaskManager/chackJobNameExist', response);
                    return callback(new Error(this.$t('error.ERROR_RESPONSE')));
                }
                if (response.data.content !== null && response.data.content !== this.editItem.jobKey) {
                    return callback(new Error(this.$t('error.ERROR_JOBNAME_EXITS')));
                }
                return callback();
            });
        };
        let cronParse = (rule, cron, callback) => {
            let param = { cron: cron };
            resourceApi.checkCron(param, response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('/timedTaskManager/chackJobNameExist', response);
                    return callback(new Error(this.$t('error.ERROR_CRON')));
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    return callback(new Error(this.$t('error.ERROR_CRON')));
                }
                return callback();
            });
        };

        return {
            // 表单信息
            fromJobInifo: {
                jobKey: '',
                jobName: '',
                groupName: '',
                jobClassPath: '',
                cron: '',
                jobDescription: '',
                concurrent: false,
                jobNumber: '1',
                logSaveDays: 6,
                errorLogSaveDays: 6
            },

            jobConcurrent: false,
            loading: false,
            messageErrorLog: '',
            jobMmessage: '',
            inputLength: 100,
            textArealength: 500,
            formLabelWidth: '80px',

            rules: {
                jobName: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') },
                    { validator: checkJobNameExist, trigger: 'blur' }
                ],
                cron: [{ required: true, message: this.$t('error.ERROR_INPUT_INFO'), trigger: 'blur' }, { validator: cronParse, trigger: 'blur' }],
                jobClassPath: [{ required: true, message: this.$t('error.ERROR_INPUT_INFO'), trigger: 'blur' }, { pattern: this.$regex.CLASS_PATH, message: this.$t('pgError.ERROR_CLASS_PATH') }],
                groupName: [{ pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }]
                // errorLogSaveDays: [{ required: true, message: this.$t('error.ERROR_INPUT_INFO'), trigger: 'blur' }, { validator: errorLogDaysCheck, trigger: 'blur' }]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.fromJobInifo.jobKey = this.editItem.jobKey;
            this.fromJobInifo.jobName = this.editItem.jobName;
            this.fromJobInifo.groupName = this.editItem.groupName;
            this.fromJobInifo.jobClassPath = this.editItem.jobClassPath;
            this.fromJobInifo.jobDescription = this.editItem.jobDescription;
            this.fromJobInifo.cron = this.editItem.cron;
            this.fromJobInifo.concurrent = this.editItem.concurrent;
            this.fromJobInifo.jobNumber = this.editItem.jobNumber;
            this.jobConcurrent = this.editItem.concurrent;
            this.fromJobInifo.updateTime = this.editItem.updateTime;
            this.fromJobInifo.addTime = this.editItem.addTime;
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loading = true;
                    let content = {
                        jobName: this.fromJobInifo.jobName,
                        groupName: this.fromJobInifo.groupName,
                        jobDescription: this.fromJobInifo.jobDescription,
                        cron: this.fromJobInifo.cron,
                        jobClassPath: this.fromJobInifo.jobClassPath,
                        concurrent: this.fromJobInifo.concurrent,
                        jobNumber: this.fromJobInifo.jobNumber
                    };
                    if (this.isAddData) {
                        resourceApi.addJob(JSON.stringify(content), response => {
                            this.loading = false;
                            if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                                this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                                return;
                            }
                            if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                return;
                            }

                            if (response.data.content) {
                                this.$message({ showClose: true, message: response.data.content, type: 'error' });
                                return;
                            } else {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                            }

                            this.$emit('submit');
                            this.jobDialogClose();
                        });
                    } else {
                        // content.jobKey = this.editItem.jobKey;
                        content.groupId = this.editItem.groupId;
                        resourceApi.modifyJob(JSON.stringify(content), response => {
                            this.loading = false;
                            if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                                this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                                return;
                            }
                            if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                return;
                            }

                            if (response.data.content) {
                                this.$message({ showClose: true, message: response.data.content, type: 'error' });
                                return;
                            } else {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                            }
                            this.$emit('submit');
                            this.jobDialogClose();
                        });
                    }
                }
            });
        },
        // 并发切换
        concurrentChange(value) {
            this.jobConcurrent = value;
            this.fromJobInifo.jobNumber = 1;
        },

        // 关闭窗口之前需要调用的方法
        jobDialogClose() {
            this.$log.info('jobDialogClose');
            this.$emit('jobDialogClose');
            this.$refs['fromJobInifo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
